<!--
 * @FileDescription: 
 * @Author: jianguo Wang
 * @Date: 2023-12-14 15:29:31
 * @LastEditors: jianguo Wang
 * @LastEditTime: 2025-01-07 
-->
<template>
  <footer class="footer-wrapper">
    <div class="footer-container">
      <!-- Main content area - 3 column layout -->
      <div class="footer-grid">
        <!-- Left - Logo -->
        <div class="footer-logo-section">
          <div class="footer-logo-wrapper">
            <img src="@/assets/apexis-logo-dark.svg" alt="Apexis Logo" class="footer-logo" />
          </div>
        </div>

        <!-- Middle - Contact Info -->
        <div class="footer-section">
          <h4 class="footer-section-title">Contact Us</h4>
          <div class="footer-links">
            <a href="mailto:info@apexis.me" class="footer-contact-item">
              <svg class="footer-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <rect x="2" y="4" width="20" height="16" rx="2" />
                <path d="m2 7 10 7 10-7" />
              </svg>
              <span>info@apexis.me</span>
            </a>
            <div class="footer-contact-item">
              <svg class="footer-icon footer-icon-pin" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
                <circle cx="12" cy="10" r="3" />
              </svg>
              <address class="footer-address">
                1 NORTH BRIDGE ROAD, #07-08<br />
                HIGH STREET CENTRE, SINGAPORE
              </address>
            </div>
          </div>
        </div>

        <!-- Right - Legal -->
        <div class="footer-section">
          <h4 class="footer-section-title">Legal</h4>
          <nav class="footer-nav">
            <router-link to="/disclaimer" class="footer-link">Disclaimer</router-link>
            <router-link to="/privacy" class="footer-link">Privacy Policy</router-link>
            <router-link to="/terms" class="footer-link">Terms & Conditions</router-link>
            <router-link to="/legal-info" class="footer-link">Legal Info</router-link>
          </nav>
        </div>
      </div>

      <!-- Copyright section -->
      <div class="footer-copyright">
        <p class="footer-copyright-text">©2025 APEXIS PTE. LTD. All rights reserved.</p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "footerPart",
  props: {
    msg: String,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style src="./footerCss/max.css" scoped></style>
<style src="./footerCss/middle.css" scoped></style>
<style src="./footerCss/flat.css" scoped></style>
<style src="./footerCss/min.css" scoped></style>
<style scoped></style>
